import React, { useEffect, useRef } from 'react';

const HubSpotMeetingScript = () => {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    if (!scriptLoaded.current) {
      // Load the script only once
      const script = document.createElement('script');
      script.src =
        'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      script.async = true;
      document.body.appendChild(script);
      scriptLoaded.current = true;
    }
  }, []);

  return (
    <>
      <div
        className='meetings-iframe-container'
        data-src='https://meetings.hubspot.com/makewebbetter/free-hubspot-consultation?embed=true'
      ></div>
    </>
  );
};

export default HubSpotMeetingScript;
